import cx from 'classnames';
import { ReactNode } from 'react';
import styles from '../sass/components/Tab.module.scss';

interface TabContainerProps {
  children?: ReactNode;
  /**
   * The booking steps: an ordered list, named for assistive tech (QA
   * 2026-09-25 #29). Its cells are then `<li>` (Tab with `step`).
   */
  steps?: boolean;
  /** Accessible name of the steps list, e.g. "Booking steps". */
  label?: string;
}

function TabContainer({ children, steps = false, label }: TabContainerProps) {
  const className = cx(styles.tabContainer, 'container--fluid', 'label');
  if (steps) {
    return (
      <ol className={className} aria-label={label}>
        {children}
      </ol>
    );
  }
  return <div className={className}>{children}</div>;
}

export default TabContainer;
